import { useCallback, useRef } from 'react'
import { Button } from '@dashboard/ui'
import { fetchUploadImage } from '@/api/files'
import { S3Bucket } from '@/types'
import { Accept, useDropzone } from 'react-dropzone'
import { useTranslation } from 'react-i18next'

interface FileUploadButtonProps {
  onChange: (value: string | null) => void
  className?: string
  accept: Accept
}

export const FileUploadButton = ({ onChange, className, accept }: FileUploadButtonProps) => {
  const { t } = useTranslation()
  const ref = useRef<HTMLButtonElement>(null)

  const onUpload = useCallback(
    async (acceptedFiles: File[]) => {
      const data = await fetchUploadImage(acceptedFiles[0], { bucket: S3Bucket.hub })
      onChange(data.get_url)
    },
    [onChange],
  )

  const { getRootProps, getInputProps } = useDropzone({
    accept,
    onDrop: onUpload,
    maxFiles: 1,
  })

  return (
    <Button color="secondary" variant="outline" className={className} {...getRootProps({ ref })}>
      <input {...getInputProps()} />
      {t('select-file')}
    </Button>
  )
}
